<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <canal-cobro-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import CanalCobroProvider from "../../../../providers/CanalCobroProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import CanalCobroForm from "../CanalCobroForm";
    
    


    export default {
        name: "CanalCobroCreate",
         
        components: { CanalCobroForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.canalCobro.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: '',
                    cuentaDestinoDefault: null,
                    tipoCanal: 'AGENCIA',
                    visiblePorAgencia: false
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    CanalCobroProvider.createCanalCobro(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createCanalCobro)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

